import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class CarService {

  constructor(private http: HttpClient) {}

  get(){
    return this.http.get(environment.apiUrl + 'cars');
  }

  updatePositions(items: any[]) {
    return this.http.post(environment.apiUrl +  'admin/car/update-positions', items);
  }

  add(data: any) {
    return this.http.post(environment.apiUrl +  'admin/car/add', data);
  }

  update(data: any) {
    return this.http.post(environment.apiUrl +  'admin/car/update' ,data);
  }

  delete(id: number) {
    return this.http.delete(environment.apiUrl +  `admin/car/destroy/${id}`);
  }
}
